<template>
  <div class="min-h-full flex flex-col justify-between">
    <!-- Heading -->
    <div class="flex justify-start items-center gap-1 w-full">
      <div class="w-2 h-2 rounded-full bg-[#FE5000]"></div>
      <div class="w-9 h-2 rounded-full bg-[#FE5000]"></div>
      <p class="text-xl font-bold pl-2 m-0 text-[#092E87]">Check</p>
    </div>

    <!-- Description -->
    <div class="w-full py-2 mt-2">
      <p class="text-lg m-0 font-normal leading-[20px] text-[#333333]">
        Please upload <span class="font-bold">front</span> and <span class="font-bold">back</span> picture of the check
      </p>
    </div>

    <!-- Upload Boxes -->
    <div class="w-full py-2 mobile:mt-0 laptop:mt-4">
      <div class="mobile:block laptop:flex gap-4">
        <!-- Front -->
        <div class="mobile:w-full laptop:w-1/2">
          <label for="frontimage" class="text-base font-normal mb-1 text-[#666666]">Check front image<span class="ml-1 text-red-500">*</span></label>
          <div class="w-full h-[150px] border-2 border-dashed border-gray-400 rounded-[10px] relative bg-[#FAFAFA]"
            @dragover.prevent @drop.prevent="onDrop($event, 'front')">
            <input type="file" ref="frontInput" accept=".png,.jpg,.jpeg" class="hidden"
              @change="onFileChange($event, 'front')" />
            <div v-if="frontImage" class="w-full h-full flex flex-col items-center justify-center">
              <img :src="frontImage" class="max-w-full max-h-[90%] object-contain" />
              <button @click="removeImage('front')"
                class="group absolute -top-4 right-2 px-2 py-1 rounded-full w-8 h-8 flex items-center justify-center transition-all border border-[#EFEFEF] bg-white hover:!bg-[#FE5000]">
                <img src="../../assets/images/trashIcon.png"
                  class="min-w-4 object-contain filter group-hover:invert group-hover:brightness-0" />
              </button>
            </div>
            <div v-else
              class="text-center min-w-full min-h-full cursor-pointer flex flex-col items-center justify-center"
              @click="$refs.frontInput.click()">
              <div class="w-[40px] h-[40px] mx-auto">
                <img src="../../assets/images/upload-icon.svg" class="w-full object-contain" />
              </div>
              <p class="text-sm font-medium mb-0 text-black-100">Click or drag and drop files to upload</p>
              <p class="text-xs mb-0 text-[#333333]">
                Supported formats: <span class="text-[#666666]">PNG, JPG</span>
              </p>
              <p class="text-xs mb-0 text-[#FE5000]">(Maximum size 10MB)</p>
            </div>
          </div>
          <span v-if="frontImageError" class="text-red-500 text-xs mt-1">This front image is required</span>
        </div>

        <!-- Back -->
        <div class="mobile:w-full laptop:w-1/2 mobile:mt-3 laptop:mt-0">
          <label for="backimage" class="text-base font-normal mb-1 text-[#666666]">Check back image<span class="ml-1 text-red-500">*</span></label>
          <div class="w-full h-[150px] border-2 border-dashed border-gray-400 rounded-[10px] relative bg-[#FAFAFA]"
            @dragover.prevent @drop.prevent="onDrop($event, 'back')">
            <input type="file" ref="backInput" accept=".png,.jpg,.jpeg" class="hidden"
              @change="onFileChange($event, 'back')" />
            <div v-if="backImage" class="w-full h-full flex flex-col items-center justify-center">
              <img :src="backImage" class="max-w-full max-h-[90%] object-contain" />
              <button @click="removeImage('back')"
                class="group absolute -top-4 right-2 px-2 py-1 rounded-full w-8 h-8 flex items-center justify-center transition-all border border-[#EFEFEF] bg-white hover:!bg-[#FE5000]">
                <img src="../../assets/images/trashIcon.png"
                  class="min-w-4 object-contain filter group-hover:invert group-hover:brightness-0" />
              </button>
            </div>
            <div v-else
              class="text-center min-w-full min-h-full cursor-pointer flex flex-col items-center justify-center"
              @click="$refs.backInput.click()">
              <div class="w-[40px] h-[40px] mx-auto">
                <img src="../../assets/images/upload-icon.svg" class="w-full object-contain" />
              </div>
              <p class="text-sm font-medium mb-0 text-black-100">Click or drag and drop files to upload</p>
              <p class="text-xs mb-0 text-[#333333]">
                Supported formats: <span class="text-[#666666]">PNG, JPG</span>
              </p>
              <p class="text-xs mb-0 text-[#FE5000]">(Maximum size 10MB)</p>
            </div>
          </div>
          <span v-if="backImageError" class="text-red-500 text-xs mt-1">This back image is required</span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { useToast } from "vue-toastification";
const toast = useToast();
export default {
  data() {
    return {
      frontImage: null,
      backImage: null,
      frontImageFile: null,
      backImageFile: null,
      frontImageError: null,
      backImageError: null

    };
  },
  computed: {
    validationCheck() {
      if (!this.frontImageFile || !this.backImageFile) return false;
      return true;
    },
  },
  watch: {
    validationCheck: {
      handler(value) {
        this.$emit("validation-change", this.validationCheck)
      },
      immediate: true,
    },
  },
  methods: {
    onFileChange(event, type) {
      const file = event.target.files[0];
      if (file) this.handleFile(file, type);
    },
    onDrop(event, type) {
      const file = event.dataTransfer.files[0];
      if (file) this.handleFile(file, type);
    },
    handleFile(file, type) {
      if (file.size > 10 * 1024 * 1024) {
        toast.error("File size exceeds 10MB")
        return;
      }
      const reader = new FileReader();
      reader.onload = async (e) => {
        if (type === "front") {
          if (file.type === "application/pdf") {
            this.frontImage =  require("../../assets/images/pdf-img.svg");
          } else if (
            file.type ===
            "application/vnd.openxmlformats-officedocument.wordprocessingml.document"
          ) {
            this.frontImage = require("../../assets/images/docs-img.svg");
          } else if (file.type.startsWith("image/")) {
            this.frontImage = e.target.result;
          } else {
            this.frontImageError = "Unsupported file type";
            return;
          }
          this.frontImageFile = file;
          this.frontImageError = null;
        } else {
          if (file.type === "application/pdf") {
            this.backImage =  require("../../assets/images/pdf-img.svg");
          } else if (
            file.type ===
            "application/vnd.openxmlformats-officedocument.wordprocessingml.document"
          ) {
            this.backImage = require("../../assets/images/docs-img.svg");
          } else if (file.type.startsWith("image/")) {
            this.backImage = e.target.result;
          } else {
            this.backImageError = "Unsupported file type";
            return;
          }

          this.backImageFile = file;
          this.backImageError = null;
        }
      };

      reader.readAsDataURL(file);
    },
    removeImage(type) {
      if (type === "front") {
        this.frontImage = null;
        this.frontImageFile = null;
        this.frontImageError = true
        if (this.$refs.frontInput) this.$refs.frontInput.value = "";
      } else {
        this.backImage = null;
        this.backImageFile = null;
        this.backImageError = true
        if (this.$refs.backInput) this.$refs.backInput.value = "";
      }
    },


    checkValidation() {
      let isValid = true;
      if (!this.frontImageFile) {
        this.frontImageError = true
        isValid = false
      } else {
        this.frontImageError = null
      }
      if (!this.backImageFile) {
        this.backImageError = true
        isValid = false
      } else {
        this.backImageError = null
      }
      return isValid;
    },

    async getData() {
      return { back_image: this.backImageFile, front_image: this.frontImageFile }
    }

  },
};
</script>
